import get from 'lodash/get';


export function getAlerts(state) {
  return get(state, 'ui.alerts', []);
}
